import React from "react";
import { routesList } from "../Common";
import BabyMintHeader from "./BabyMintHeader";
import Banner from "./Banner";
import Header from "./Header";
import Mint from "./Mint";
import Registration from "./Registration";
import TokenHolder from "./TokenHolder";
import UtilitiesHeader from "./UtilitiesHeader";

const home = () => {
  return (
    <>
      <div id="particles-js" className="particles-js"></div>
      <Header />
      <Banner />
    </>
  );
};

const mint = () => {
  return (
    <>
      <Header />
      <Mint />
    </>
  );
};

const register = () => {
  return (
    <>
      <Header />
      <Registration />
    </>
  );
};

const tokenHolder = () => {
  return (
    <>
      <Header />
      <TokenHolder />
    </>
  );
};

const babyMint = () => {
  return (
    <>
      <Header />
      <BabyMintHeader />
    </>
  );
};

const utilities = () => {
  return (
    <>
      <Header />
      <UtilitiesHeader />
    </>
  );
};

const HeaderContainer = () => {
  const components = {
    [routesList.homePage]: home(),
    [routesList.mint]: mint(),
    [routesList.token_registration]: register(),
    [routesList.token_holder]: tokenHolder(),
    [routesList.baby_mint]: babyMint(),
    [routesList.utilities]: utilities(),
  };

  return (
    <>
      <div
        className={
          "top " +
          (window.location.pathname !== routesList.homePage
            ? "mint-header "
            : "") + (window.location.pathname === routesList.baby_mint
              ? "baby-header"
              : "")
        }
      >
        {components[window.location.pathname]}
      </div>
    </>
  );
};

export default HeaderContainer;
